import React from "react";
import {
  workImgOne,
  workImgTwo,
  workImgThree,
  workImgFour,
  // workImgFive,
  // workImgSix,
  // workImgSeven,
  // workImgEight,
} from "../../assets";
import Title from "../home/Title";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  return (
    <div>
      <Title title="Recent" subTitle="Projects" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <ProjectsCard
            title="Islamic Prayer Times"
            category="Tailwind CSS"
            image={workImgOne}
            link="https://shalat.syafiqibrahim.my.id"
          />
          <ProjectsCard
            title="Twitter Clone"
            category="NextJS"
            image={workImgTwo}
            link="https://x.syafiqibrahim.my.id"
          />
          {/* <ProjectsCard
            title="Infinity Logo"
            category="Logo"
            image={workImgThree}
          />
          <ProjectsCard
            title="Mobile Application"
            category="Shopping"
            image={workImgFive}
          /> */}
        </div>
        <div className="px-6">
          <ProjectsCard
            title="Anime Website"
            category="NextJS"
            image={workImgThree}
            link="https://anime.syafiqibrahim.my.id"
          />
           <ProjectsCard
            title="Basic ERP"
            category="FRAPPE"
            image={workImgFour}
            link="https://github.com/Qifaysibr/umkm"
          />
          {/*<ProjectsCard
            title="Ideas & Blog"
            category="Website"
            image={workImgEight}
          />
          <ProjectsCard
            title="ZOSS Logo"
            category="Logo"
            image={workImgSeven}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default Projects;
